import {
    IAppConfig,
    IFederatedService,
    ServiceInitializer,
    root
} from '@estee/elc-universal-utils';
import { ELCLogger, TriggerType } from '@estee/elc-logging';

root.ServiceRegistry = root.ServiceRegistry || {};

export abstract class BaseService {
    private startPromise: Promise<void>;
    public isStarted: boolean = false;
    protected logger: ELCLogger;

    static setViews(serviceName: string, name: string, version: string, views: string[]) {
        root.ServiceRegistry[serviceName] = {
            name,
            version,
            views,
            isStarted: true
        } as IFederatedService;
    }

    constructor(
        public name: string,
        private version: string,
        private serviceInitializer: ServiceInitializer
    ) {}

    private async initializeService(appConfig: IAppConfig): Promise<void> {
        try {
            await this.serviceInitializer(appConfig);
            this.isStarted = true;
        } catch (error) {
            this.logger.error({
                message: `Could not start service ${this.name}`,
                triggerType: TriggerType.render,
                payload: {
                    error,
                    context: {
                        serviceRegistry: root.ServiceRegistry
                    }
                }
            });
        } finally {
            this.isStarted = true;
        }
    }

    public start = (appConfig: IAppConfig): Promise<void> => {
        if (!this.startPromise && !this.isStarted) {
            this.logger =
                this.logger ||
                new ELCLogger({
                    serviceName: this.name,
                    environment: appConfig.env || root.env,
                    buid: appConfig.businessUnitId || root.buid,
                    serviceVersion: this.version
                });

            this.startPromise = this.initializeService(appConfig);
        }

        return this.startPromise as Promise<void>;
    };
}
